module.exports = __webpack_public_path__ + "static/media/folder.599a25f7.svg";